import React from 'react';
import Button from 'react-bootstrap/Button';
import '../style/navbar.css';

class SignOut extends React.Component {
  render(){
    return(
      <Button 
        size="sm"
        className="bg-important text-light"
        onClick={()=>this.props.signOut()}
        id="logout-button"
      >
        Logout
      </Button>
    )
  }
}

export default SignOut;